import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Result, Button, Tag, Divider } from 'antd';
import Search from 'antd/lib/input/Search';
import moment from 'moment';
import { LeftOutlined } from '@ant-design/icons';
import { getRestaurant } from '../../../reducers';
import LoadingPage from '../../../components/LoadingPage';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants/nodes_database';
import UsersAssistedRestaurantTable from '../../../components/tables/UsersAssistedRestaurantTable';
import './styles.css';
import ReservationsForUserDNITable from '../../../components/tables/ReservationsForUserDNITable';

function compareReservationDate( a, b ) {
    var dateA = moment(a.date, 'DD/MM/YYYY');
    var dateB = moment(b.date, 'DD/MM/YYYY');
    var hourA = moment(a.hour, 'HH:mm');
    var hourB = moment(b.hour, 'HH:mm');

    if ( dateA.isBefore(dateB) ) {
        return 1;
    }
    if ( dateA.isAfter(dateB) ) {
        return -1;
    }
    if ( a.hour === "00:00" && b.hour === "00:00" ) {
        return 0;
    }
    if ( a.hour === "00:00" ) {
        return 1;
    }
    if ( b.hour === "00:00" ) {
        return -1;
    }
    if ( hourA.isBefore(hourB) ) {
        return -1;
    }
    if ( hourA.isAfter(hourB) ) {
        return 1;
    }
    return 0;
};

function compareAssistedField( a, b ) {
    if ( a.assisted ) {
        if(b.assisted) {
            return 0;
        } else {
            return -1;
        }
    } else {
        if(b.assisted) {
            return 1;
        } else {
            return 0;
        }
    }
};

const ReservationsUsersAssisted = props => {
    const[assistedReservations, setAssistedReservations] = useState(null)
    const[usersByDNI, setUsersByDNI] = useState([])
    const[gettingUsers, setGettingUsers] = useState(false)
    const[emptyUsers, setEmptyUsers] = useState(false)
    const[userDNISelected, setUserDNISelected] = useState(null)
    const[reserveIDSelected, setReserveIDSelected] = useState(null)
    const[filterDNI, setFilterDNI] = useState("")

    const getAssistedReservations = restaurantId => {
        setGettingUsers(true)
        db.ref(`${Constants.RESERVATIONS_ASSISTED_BY_RESTAURANT}/${restaurantId}`).once("value")
        .then((snapshot) => {
            if(snapshot.exists()) {
                const reservationsIds = snapshot.val();
                var reservations = {};
                const promiseGetReservations = [];
                Object.keys(reservationsIds).forEach(reservationId => {
                   const getReservationRef = db.ref(`${Constants.RESERVATIONS}/${reservationId}`).once("value")
                   .then(reserveSnap => {
                       if(reserveSnap.exists()) {
                            const reserve = reserveSnap.val();
                            reservations[reserve.reservationId] = reserve;
                       }
                   })
                   promiseGetReservations.push(getReservationRef);
                });
                Promise.all(promiseGetReservations)
                .then(() => {
                    if(Object.keys(reservations).length > 0) {
                        var usersByDNILoaded = {};
                        Object.values(reservations).forEach(reserve => {
                            if(reserve.users) {
                                reserve.users.forEach(user => {
                                    if(user.assisted) {
                                        if(usersByDNILoaded[user.dni] === undefined) {
                                            usersByDNILoaded[user.dni] = {}
                                        }
                                        usersByDNILoaded[user.dni][reserve.reservationId] = user
                                    }
                                });
                            }
                        });
                        if(Object.keys(usersByDNILoaded).length > 0) {
                            setUsersByDNI(usersByDNILoaded)
                            setAssistedReservations(reservations)
                            setEmptyUsers(false)
                            setGettingUsers(false)
                        } else {
                            setAssistedReservations({})
                            setEmptyUsers(true)
                            setGettingUsers(false)    
                        }
                    } else {
                        setAssistedReservations({})
                        setEmptyUsers(true)
                        setGettingUsers(false)
                    }
                })
                .catch(() => {
                    setAssistedReservations({})
                    setEmptyUsers(true)
                    setGettingUsers(false)
                })
            } else {
                setAssistedReservations({})
                setEmptyUsers(true)
                setGettingUsers(false)
            }
        })
        .catch(err => {
            setAssistedReservations({})
            setEmptyUsers(true)
            setGettingUsers(false)
        });
    }

    const renderUsersTableByDNI = (users, filter) => {
        const data = []
        Object.keys(users).forEach(userDNI => {
            if(filter === "" || userDNI.includes(filter)) {
                const customObjectData = {};
                customObjectData["dni"] = userDNI;
                customObjectData["reservationsCount"] = Object.keys(users[userDNI]).length;
                const firstNames = [];
                const lastNames = [];
                const emails = [];
                Object.keys(users[userDNI]).forEach(reserveID => {
                    const userByReserve = users[userDNI][reserveID]
                    if(firstNames.indexOf(userByReserve.firstName) === -1) {
                        firstNames.push(userByReserve.firstName);
                    }
                    if(lastNames.indexOf(userByReserve.lastName) === -1) {
                        lastNames.push(userByReserve.lastName);
                    }
                    if(emails.indexOf(userByReserve.email) === -1) {
                        emails.push(userByReserve.email);
                    }
                });
                customObjectData["firstNames"] = firstNames;
                customObjectData["lastNames"] = lastNames;
                customObjectData["emails"] = emails;
                data.push(customObjectData);
            }
        });
        return <UsersAssistedRestaurantTable data={data} userSelected={dni => setUserDNISelected(dni)}/>
    }

    const renderReservationsForUserDNITable = dni => {
        const data = []
        const userReservations = usersByDNI[dni];
        if(userReservations) {
            Object.keys(userReservations).forEach(reserveID => {
                const customObjectData = {};
                const userByReserve = userReservations[reserveID]
                customObjectData["reserveID"] = reserveID;
                customObjectData["date"] = assistedReservations[reserveID] ? assistedReservations[reserveID]["date"] : "";
                customObjectData["hour"] = assistedReservations[reserveID] ? assistedReservations[reserveID]["hour"] : "";
                customObjectData["checkIn"] = userByReserve.checkInRestaurant;
                customObjectData["checkOut"] = userByReserve.checkOutRestaurant;
                customObjectData["temperature"] = userByReserve.temperature;
                data.push(customObjectData);
            });
        }
        data.sort(compareReservationDate);
        return <ReservationsForUserDNITable data={data} reserveSelected={id => setReserveIDSelected(id)}/>
    }

    const renderReservationIDData = id => {
        const reserve = assistedReservations[id];
        const users = reserve.users ? reserve.users : [];
        users.sort(compareAssistedField);
        return(
            <Col xs={12} className="reserveInformationCont">
                <Row center="xs">
                    <Col xs={12} md={4}>
                        <h2>Fecha: {reserve.date}</h2>
                    </Col>
                    <Col xs={12} md={4}>
                        <h2>Hora: {reserve.hour}</h2>
                    </Col>
                    <Col xs={12} md={4}>
                        <h2>Cantidad de personas: {reserve.peopleCount}</h2>
                    </Col>
                </Row>
                <Divider orientation="left">Usuarios</Divider>
                {
                    reserve.users &&
                        users.map(user =>
                            <Row center="xs">
                                <Col xs={12} md={4}>
                                    <h3>{user.reserveOwner ? "Dueño de la reserva:" : "Invitado:"} {`${user.firstName} ${user.lastName}`}</h3>
                                </Col>
                                <Col xs={12} md={4}>
                                    <h3>DNI: {user.dni}</h3>
                                </Col>
                                {
                                    user.assisted ?
                                        <Col xs={12} md={4}>
                                            <Tag color="geekblue">Asistió</Tag>
                                        </Col>
                                        :
                                        <Col xs={12} md={4}>
                                            <Tag color="red">No asistió</Tag>
                                        </Col>
                                }
                                <Col xs={12}>
                                    <Row>
                                        <Col xs={12} md={4}>
                                            <h3>Ingreso: {user.checkInRestaurant}</h3>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <h3>Egreso: {user.checkOutRestaurant}</h3>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <h3>Temperatura: {user.temperature !== "" ? `${user.temperature}ºC` : "--"}</h3>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12}>
                                    <Row center="xs">
                                        <Col xs={8}>
                                            <Divider></Divider>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )
                }
            </Col>
        )
    }

    return (
        <Grid className="reservationsUsersAssistedCont">
            {
                props.restaurant ?
                    assistedReservations ?
                        emptyUsers ?
                            <Result
                                status="404"
                                title="No hay usuarios"
                                subTitle="Lo sentimos, no se encontro ninguna reserva con usuarios asistidos."
                            />
                            :
                            reserveIDSelected ?
                                <Row>
                                    <Col xs={4}>
                                        <Button className="buttonBackReserveID" icon={<LeftOutlined />} onClick={() => setReserveIDSelected(null)}>Volver al usuario</Button>
                                    </Col>
                                    {renderReservationIDData(reserveIDSelected)}
                                </Row>
                                :
                                userDNISelected ?
                                    <Row>
                                        <Col xs={4}>
                                            <Button className="buttonBackUserDNI" icon={<LeftOutlined />} onClick={() => setUserDNISelected(null)}>Ver usuarios</Button>
                                        </Col>
                                        <Col xs={12}>
                                            <Row center="xs">
                                                <Col xs={12} md={11}>
                                                    {renderReservationsForUserDNITable(userDNISelected)}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    :
                                    <Row center="xs">
                                        <Col xs={12} md={10} lg={6}>
                                            <Search className="searchUsersDNI" placeholder="DNI del usuario" onSearch={(value) => setFilterDNI(value)} enterButton />
                                        </Col>
                                        <Col xs={12} md={11}>
                                            {renderUsersTableByDNI(usersByDNI, filterDNI)}
                                        </Col>
                                    </Row>
                        :
                        gettingUsers ?
                            <LoadingPage />
                            :
                            getAssistedReservations(props.restaurant.id)
                    :
                    <LoadingPage />
            }
        </Grid>
    );
}

ReservationsUsersAssisted.propTypes = {

};

const mapDispatchToPropsActions = dispatch => ({
});

const mapStateToProps = state => ({ 
    restaurant:  getRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ReservationsUsersAssisted));